export default "__VITE_ASSET__Dz7Hun1r__"